module.exports = {
	"hasAccountCredit": false,
	"lowestPrice": 73,
	"creditAmount": 50,
	"contractTerm": "12 month",
	"openTermDescriptor": "No term",
	"homeUrl": "https://www.skinny.co.nz/broadband/",
	"modemPrice": 199,
	"modemName": "Skinny Smart Modem 3",
	"connectionFee": 49,
	"earlyTerminationFee": 249,
	"moveFee": 50,
	"offer": {
		"enabled": false,
		"name": "",
		"value": 0
	},
	"discount": {
		"enabled": false,
		"name": "",
		"value": 0
	},
	"subscriptionDiscount": {
		"duration": 1,
		"unit": "month",
		"durationString": "one month"
	},
	"skinnyMobileCustomerDiscount": {
		"name": "Skinny mobile bundle discount",
		"amount": -10,
		"amountText": "-$10"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/Configuration.json
 ** module id = 38
 ** module chunks = 0
 **/